export default function KitchenOrderCard({ order }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-4">
      <p className="text-xs text-gray-400">Order #{order.id}</p>
      <h3 className="font-serif text-lg mt-1">{order.item}</h3>

      <span
        className={`mt-3 inline-block px-3 py-1 rounded-full text-xs ${
          order.status === "Preparing"
            ? "bg-yellow-500/20 text-yellow-400"
            : "bg-emerald-500/20 text-emerald-400"
        }`}
      >
        {order.status}
      </span>
    </div>
  );
}
